import api from "@helpers/api";

import { URLS } from "@constants/urls";

import { GeneralInfoType } from "@type/HRM/general-info";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${URLS.EMPLOYEES}`;

export const createGeneralInfo = (() => {
  return async (data: {
    data: GeneralInfoType;
  }): Promise<{ data: GeneralInfoType }> => {
    return api
      .post(`${apiEndPoint}/general-info`, {
        ...data.data,
        rankId: 2,
        genderId: Number(data.data.genderIdStr),
        designationId: data.data.positionId, // Have to remove it after API fix !!!
      })
      .then((response) => ({ data: response.data }));
  };
})();

export const getGeneralInfo = (() => {
  return async (data: { data: number }): Promise<{ data: GeneralInfoType }> => {
    const id = data.data;
    return api
      .get(`${apiEndPoint}/${id}/general-info`)
      .then((response) => ({ data: response.data }));
  };
})();

export const updateGeneralInfo = (() => {
  return async (data: {
    data: GeneralInfoType;
  }): Promise<{ data: GeneralInfoType }> => {
    const { employeeID, ...rest } = data.data;

    return api
      .put(`${apiEndPoint}/${employeeID}/general-info`, { ...rest })
      .then((response) => ({ data: response.data }));
  };
})();
